export default __webpack_public_path__ + "static/media/teachings_of_gold.f188eb87.png";